import React,{Component} from 'react'
import TopInfo from './TopInfo'
import Search from './Search'
import Table from './Table'
import Styles from './style.module.less'
import {observer} from 'mobx-react'
import store from './store'

@observer
export default class extends Component{
    componentDidMount(){
        store.getWallet()
        store.getDetail()
    }
    render(){
        const {amount,detail}=store
        return(
            <div className={Styles.myorder}>
                <div className={Styles.myorderTit}>
                    <h3>结算管理</h3>
                </div>
                <div className={Styles.myorderBox}>
                    {
                        detail.id&&<TopInfo />
                    }

                    <div className={Styles.box}>
                        <Search />
                    </div>

                    <div className={Styles.allPrice}>
                        成交总额：<i>{amount}元</i>
                    </div>

                    <Table/>
                </div>
            </div>
        )
    }
}